// Path builders for the Workflows Visualization page, mirroring supportUrls.js.
// View and doctor both live in the path, so a route answer can be pasted into a
// ticket: /workflows/visualization/table/<doctor id>. Specialty stays local —
// it filters a view rather than naming what the page is about.

const BASE_PATH = "/workflows/visualization";

// "tree" answers "how does this specialty route?", "table" answers "what does
// this doctor get?". The segment doubles as the page's view mode.
export const TREE_VIEW = "tree";
export const TABLE_VIEW = "table";

const VIEWS = [TREE_VIEW, TABLE_VIEW];

export function isWorkflowView(view) {
  return VIEWS.includes(view);
}

/** The landing screen, where you pick which of the two views you want. */
export function workflowsChooserPath() {
  return BASE_PATH;
}

/** One view with no doctor pinned. */
export function workflowsViewPath(view) {
  const segment = isWorkflowView(view) ? view : TREE_VIEW;
  return `${BASE_PATH}/${segment}`;
}

/**
 * One doctor's routes, keyed by the `user_id` the config stores on a route's
 * `providers[]` and other dashboards already hold:
 *
 *   <Link to={doctorWorkflowsPath(doctor.user_id)}>Workflows</Link>
 *
 * An empty id falls back to the doctor-less view rather than a trailing-slash
 * path, as templatePath does with an empty term.
 */
export function doctorWorkflowsPath(doctorId, { view = TABLE_VIEW } = {}) {
  const id = (doctorId || "").trim();
  if (!id) return workflowsViewPath(view);

  const segment = isWorkflowView(view) ? view : TABLE_VIEW;
  return `${BASE_PATH}/${segment}/${encodeURIComponent(id)}`;
}

/** Absolute form, for pasting somewhere outside the app (cf. sharedSessionUrl). */
export function doctorWorkflowsUrl(doctorId, options) {
  return `${window.location.origin}${doctorWorkflowsPath(doctorId, options)}`;
}
